import React from 'react'
import { Routes, Route } from "react-router-dom";

import { PedidoScreen } from '../componentes/view/comercial/traslado/pedido/PedidoScreen';
import { MarcajeScreen } from '../componentes/view/comercial/reporte/marcaje/MarcajeScreen';
import { ValeScreen } from '../componentes/view/comercial/vales/ValeScreen';
import { EmbajadorScreen } from '../componentes/view/comercial/asignacion/embajador/EmbajadorScreen';

export const ComercialRoutes = () => {

  return (
    <Routes>
      <Route path="traslado/pedido" element={ <PedidoScreen /> } />
      <Route path="reporte/marcaje" element={ <MarcajeScreen /> } />
      <Route path="vales" element={ <ValeScreen /> } />
      <Route path="vales/:id_rastreo" element={ <ValeScreen /> } />
      <Route path="tienda/embajador" element={ <EmbajadorScreen /> } />
    </Routes>
  )
}
